import { Component } from '@angular/core'

@Component({
  selector: 'spinner-icon',
  templateUrl: './spinnerIcon.component.pug',
  styleUrls: ['./spinnerIcon.component.scss'],
})
export class SpinnerIconComponent { }
